import { isMobile } from "mobile-device-detect";
import React from "react";
import DPricing from "./DPricing";
import MPricing from "./MPricing";

export default function Pricing() {
  return isMobile ? <MPricing /> : <DPricing />;
}
